import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  howToUseDropOffStorageSectionContent,
  serviceTipsSectionSectionContent,
  whatToExpectAtOurDropOffLocationsSectionContent,
  whyChooseUsSectionContent
} from '@/v2/constants/pages/public-pages/drop-off-location-page'

interface DropOffLocationPageProps {}

const DropOffLocationPage: React.FC<DropOffLocationPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[345px] max-h-[232px] 
        md-mn:w-[330px] md-mn:max-h-[322px] 
        lg:!w-[476px] lg:!max-h-[320px] 
        xl-min:!w-[680px] xl-min:!max-h-[458px]
      '
        btnClassName='xl-min:!w-[314px] xl-min:h-[50px] md-mn:w-[266px] w-[291px] h-[44px]'
      />
      <HelperSection
        {...howToUseDropOffStorageSectionContent}
        isBgDark
        className={`
          lg-mn:[&>div>div:last-of-type>div]:gap-0 
          xl-min:[&>div>div:last-of-type>div]:!gap-10 
          lg-mn:[&>div>div:last-of-type>div>div:last-of-type]:pr-20 
          xl-min:[&>div>div:last-of-type>div>div:last-of-type]:!pr-0
          `}
      />
      <WhyWeSection {...whyChooseUsSectionContent} />
      <HelperSection
        {...whatToExpectAtOurDropOffLocationsSectionContent}
        isInverted={true}
        isBgDark
        className={`
          lg-mn:[&>div>div:last-of-type>div]:gap-0 
          xl-min:[&>div>div:last-of-type>div]:!gap-10 
          lg-mn:[&>div>div:last-of-type>div>div:last-of-type]:pl-20 
          xl-min:[&>div>div:last-of-type>div>div:last-of-type]:!pl-0
          `}
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionSectionContent}
        sectionTitleClassName='md-mn:w-full md-mn:[&_p]:w-full [&_p]:w-[95%]'
        className='
        xl-min:[&_button]:!w-[280px]
        lg-mn:[&_button]:w-[255px]
        md-mn:[&_button]:w-[251px] 
        [&_button]:w-[245px]'
      />
      <BenefitsSection
        {...benefitsSectionSectionContent}
        isBgDark
        className='
        md-mn:[&_article>div:first-of-type]:self-start 
      '
      />
      <ForWhoSection {...forWhoSectionContent} sectionTitleClassName='md-mn:w-full w-[90%]' />
      <FaqSection {...faqSectionContent} isBgDark />
    </>
  )
}

export default DropOffLocationPage
